export default "__VITE_ASSET__dvFXXO6w__"